import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const BreadCrumbs = ({ breadcrumbs }) => {
  const navigate = useNavigate();
  const [isBackClicked, setIsBackClicked] = useState(false);

  const handleBackClick = () => {
    setIsBackClicked(true);
    if (breadcrumbs.length > 1) {
      const previousPath = breadcrumbs[breadcrumbs.length - 2].link;
      if (previousPath) {
        navigate(previousPath);
      }
    }
  };

  return (
    <div className="page__breadcrumbs">
      <ul className="breadcrumb">
        {breadcrumbs?.map((crumb, index) => (
          <li
            key={index}
            className="breadcrumb__item"
          >
            {crumb.link ? (
              <a
                className="breadcrumb__link"
                onClick={() => navigate(crumb.link)}
              >
                <span className="cursor-pointer opacity-50 hover:opacity-100">{crumb.label}</span>
              </a>
            ) : (
              <span className="breadcrumb__link">
                {index === breadcrumbs.length - 1 && breadcrumbs.length > 1 && !isBackClicked && (
                  <button onClick={handleBackClick} className="backBtn">
                    <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M13.5 9L8.5 14M8.5 14L13.5 19M8.5 14H18.5M26 14C26 20.9036 20.4036 26.5 13.5 26.5C6.59644 26.5 1 20.9036 1 14C1 7.09644 6.59644 1.5 13.5 1.5C20.4036 1.5 26 7.09644 26 14Z"
                        stroke="#ffffff"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                )}
                <span>{crumb.label}</span>
              </span>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BreadCrumbs;
